import { getAllDeployments } from 'apis/rest/on-site/deployments';

const PAGE_LIMIT = 100;
const MAX_PAGES = 500;

/**
 * Loads all deployments for query-builder select options (paginated API).
 */
async function fetchAllDeploymentsForQueryBuilder(projectId) {
    if (!projectId) {
        return [];
    }

    const all = [];
    let page = 1;

    while (page <= MAX_PAGES) {
        // eslint-disable-next-line no-await-in-loop
        const resp = await getAllDeployments({
            projectId,
            page,
            limit: PAGE_LIMIT,
            sortBy: 'updatedAt',
            sortOrder: 'desc',
        });

        if (!resp?.status) {
            break;
        }

        const batch = resp.deployments || [];
        all.push(...batch);

        const pag = resp.pagination;
        const totalPage = pag != null ? Number(pag.totalPage) : null;
        if (totalPage != null && !Number.isNaN(totalPage)) {
            if (page >= totalPage || batch.length === 0) {
                break;
            }
        } else if (batch.length < PAGE_LIMIT || batch.length === 0) {
            break;
        }

        page += 1;
    }

    return all;
}

export default fetchAllDeploymentsForQueryBuilder;
